import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var honor = new Swiper(".section2 .mySwiper", {
    slidesPerView: 6,
    spaceBetween: '1.82%',
    loop:true,
    speed:2000,//匀速时间
    autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 6,
        spaceBetween: '3.82%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 4,
        spaceBetween: '1.82%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      }
    } 
});